import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataVariaveisReducer } from "../reducers";
import { InitialStateVariaveis } from "./models";

const initialState: InitialStateVariaveis = {
  items: [],
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {},
  pagination: {
    page: 1,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
};

const variaveisSlice = createSlice({
  name: "variaveisApp/variavies",
  initialState,
  reducers: {
    openDialogForm: (state, action) => {
      state.dialogForm = {
        open: true,
        content: action.payload,
      };
    },
    closeDialogForm: (state) => {
      state.dialogForm = {
        open: false,
        content: {
          mode: "",
          values: null,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getVariaveis.fulfilled, dataVariaveisReducer);
  },
});

export const { openDialogForm, closeDialogForm } = variaveisSlice.actions;

export default variaveisSlice.reducer;
